import { TopPromo } from "../../../api/payments/overview/overview.responses";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/Table";

interface TopPromoCodesCardProps {
  topPromos: TopPromo[];
}

export function TopPromoCodesCard({ topPromos }: TopPromoCodesCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Top Promo Codes</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {topPromos.length === 0 ? (
          <p className="px-6 pb-4 text-sm text-muted-foreground">
            No promo codes used yet.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Code</TableHead>
                <TableHead>Partner</TableHead>
                <TableHead className="text-right">Completed</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {topPromos.map((p) => (
                <TableRow key={p.id}>
                  <TableCell className="font-mono text-sm">{p.code}</TableCell>
                  <TableCell className="text-muted-foreground">
                    {p.partnerName ?? "—"}
                  </TableCell>
                  <TableCell className="text-right">
                    {p.completedRedemptions} / {p.totalApplications}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
